import { render, staticRenderFns } from "./default-column.md?vue&type=template&id=5885e42a&"
import script from "./default-column.md?vue&type=script&lang=js&"
export * from "./default-column.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5885e42a')) {
      api.createRecord('5885e42a', component.options)
    } else {
      api.reload('5885e42a', component.options)
    }
    module.hot.accept("./default-column.md?vue&type=template&id=5885e42a&", function () {
      api.rerender('5885e42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Column/default-column.md"
export default component.exports